import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../utils/decodeHtml";

function Policy() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const isPdf = (content) => {
    if (!content) return false;

    return content
      .split("?")[0]
      .toLowerCase()
      .endsWith(".pdf");
  };
  const [options, setoptions] = useState([]);
  const foptions = useRef();
  const columns = [
    {
      accessorKey: "subject",
      header: "Policy",
      size: 350,

      Cell: ({ row }) => (
        <button
          type="button"
          className="btn btn-link p-0 text-start"
          style={{
            textDecoration: "none",
            fontWeight: 500,
          }}
          onClick={() => handleViewPolicy(row.original)}
          title={row.original.subject}
        >
          {decodeHtml(row.original.subject)}
        </button>
      ),
    },
    {
      accessorKey: "created_by",
      header: "Created By",
      size: 150,
      Cell: ({ cell }) => (
        <span
          title={cell.getValue()}
          style={{
            display: "inline-block",
            maxWidth: "150px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {cell.getValue()}
        </span>
      ),
    },
    {
      accessorKey: "created",
      header: "Created Date",
      size: 70,
      Cell: ({ row }) => {
        const date = new Date(row.original.created);
        return <>{date.toLocaleDateString()}</>;
      },
    },
  ];
  const fetchOptions = async () => {
    setGlobalLoading(true); //  Show loader before API call
    try {
      const response = await axios.get(
        `${API_BASE_URL}/employeeinfos/get_policy_list/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setoptions(response.data.policy_list || []);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (foptions.current) return;
    foptions.current = true;
    fetchOptions();
  }, []);

  useEffect(() => {
    if (options.length > 0) {
      setGlobalLoading(false);
      console.log(options);
    }
  }, [options]);

  const handleViewPolicy = (policy) => {
    setSelectedPolicy(policy);
    setShowPolicyModal(true);
  };

  const handleClosePolicy = () => {
    setShowPolicyModal(false);
    setSelectedPolicy(null);
  };

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">My Policy</h2>
          </div>
        </div>

        <div className="card">
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <div className="row p-4 mt-3">
                {options.length > 0 && (
                  <MaterialReactTable
                    columns={columns}
                    data={options}
                    enableColumnFilters
                    enableGrouping
                    initialState={{
                      density: "compact",
                      expanded: true, // expand groups by default
                      pagination: { pageSize: 100 },
                      columnOrder: [
                        "subject",
                        "created_by",
                        "created_date",
                      ],
                      columnPinning: {
                        left: [], // 👈 no pinned columns
                        right: [],
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {showPolicyModal && selectedPolicy && (
        <div className="modal fade show" style={{display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)"}} tabIndex="-1" role="dialog" aria-modal="true">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document" style={{maxWidth: "1200px"}}>
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <div>
                  <h5 className="modal-title mb-1">
                    {decodeHtml(selectedPolicy.subject)}
                  </h5>

                  {selectedPolicy.created_by && (
                    <small className="text-muted">
                      Created by: {selectedPolicy.created_by}
                    </small>
                  )}
                </div>
                <button type="button" className="btn-close" onClick={handleClosePolicy} aria-label="Close" />
              </div>

              {/* Body */}
              <div className="modal-body">
                {/* Subject */}
                <div className="mb-4">
                  <strong>Subject:</strong>
                  <span className="ms-2">
                    {decodeHtml(selectedPolicy.subject || "-")}
                  </span>
                </div>
                {/* PDF */}
                {isPdf(selectedPolicy.content) ? (
                  <div>
                    <iframe
                      src={`${API_BASE_URL}/files/policy/${selectedPolicy.content}`}
                      width="100%"
                      height="700px"
                      frameBorder="0"
                      title={selectedPolicy.subject}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                ) : (
                  /* HTML / Text Content */
                  <div>
                    <strong>Content:</strong>

                    {selectedPolicy.content ? (
                      <div
                        className="policy-content mt-2"
                        dangerouslySetInnerHTML={{
                          __html: selectedPolicy.content,
                        }}
                      />
                    ) : (
                      <div className="text-muted mt-2">
                        -
                      </div>
                    )}
                  </div>
                )}

              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClosePolicy}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
      </div>
    </>
  );
}

export default Policy;
